import React, { useEffect, useState } from 'react';
import AuthService from '../../controllers/AuthService';
import { Row, Col, Card } from 'react-bootstrap';
import MultiCarouselPage from '../MultiCarouselPage';


const MenuCard = props => {

    const roomId = props.roomId ?? null
    const userFeature = AuthService.getCurrentUserFeatures();
    const [cardItems, setCardItems] = useState([]);
    let allData = [];

    useEffect(() => {
        renderMenu()
    }, [roomId])

    const exportLink = (link) => {
        if (link) {
            window.open(link, '_blank').focus();
        }
    }

    const renderMenu = () => {
        let result = [];
        if (userFeature && userFeature.includes('homeroom')) {
            result.push({
                'description': 'มาร่วมกันค้นหาคุณค่าผ่าน<span class="doNotWrap">นิสัยเชิงบวก</span>จากเรื่องราวที่สร้าง<span class="doNotWrap">แรงบันดาลใจ</span>ของคนทั่วโลก',
                'image': '/images/card/homeroom_new.jpg',
                'link': '/report/overview/' + roomId,
                'btnText': 'homeroom'.toUpperCase(),
                'id': 'url-Link',
            })
        }
        if (userFeature && userFeature.includes('friendship')) {

            if( AuthService.getUserRole() === 'student'){
                result.push({
                    'description': 'คนทุกคนล้วนมีคุณค่าในตัวเอง มาร่วมกันสื่อสารคุณค่าที่มีอยู่ในตัวเรา <span class="doNotWrap">และคนรอบข้าง</span>ให้สัมผัสถึงคุณค่าเชิงบวกของตัวเอง',
                    'image': '/images/card/friendship.jpg',
                    'link': '/report/friendship/' + roomId,
                    'btnText': 'friendship'.toUpperCase(),
                    'id': 'url-Friendship'

                })
            } else {
                result.push({
                    'description': 'คนทุกคนล้วนมีคุณค่าในตัวเอง มาร่วมกันสื่อสารคุณค่าที่มีอยู่ในตัวเรา <span class="doNotWrap">และคนรอบข้าง</span>ให้สัมผัสถึงคุณค่าเชิงบวกของตัวเอง',
                    'image': '/images/card/friendship.jpg',
                    'link': '/report/friendship/' + roomId,
                    'btnText': 'friendship'.toUpperCase(),
                    'id': 'url-Friendship',
                    'csvId': 'csv-id-friendship',
                    'csvLink': `${process.env.REACT_APP_API_ENDPOINT}/api/` + "rooms/" + roomId + "/friendship-status/export"

                })
            }
        }
        if (userFeature && userFeature.includes('pocket-book')) {
            
            result.push({
                'description': 'สมุดพกที่จะเปลี่ยนคำนิยามเดิมๆ เกี่ยวกับคุณค่า และอุปนิสัยเชิงบวกของนักเรียน',
                'image': '/images/card/pocketbook.jpg',
                'link': '/pocketbook/' + roomId,
                'btnText': 'ดูรายงาน',
                'id': 'url-pocketbook',
            })
        }
        if (userFeature && userFeature.includes('riasec')) {

            if( AuthService.getUserRole() === 'student'){
                result.push({
                    'description': 'แบบวัดเพื่อสำรวจบุคลิกภาพและความสนใจทางอาชีพ (RIASEC)',
                    'image': '/images/riasec/riasec.jpg',
                    'link': '/report/riasec/' + roomId,
                    'btnText': 'riasec'.toUpperCase(),
                    'id': ''
                })
            } else {

                result.push({
                    'description': 'แบบวัดเพื่อสำรวจบุคลิกภาพและความสนใจทางอาชีพ (RIASEC)',
                    'image': '/images/riasec/riasec.jpg',
                    'link': '/report/riasec/' + roomId,
                    'btnText': 'riasec'.toUpperCase(),
                    'id': 'url-riasec',
                    'csvId': 'csv-id-riasec',
                    'csvLink': `${process.env.REACT_APP_API_ENDPOINT}/api/` + "rooms/" + roomId + "/riasec-status/export"
                })

                
            }

        }
        setCardItems(result)
    }


    const responsive2 = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3,
            partialVisibilityGutter: 40 // this is needed to tell the amount of px that should be visible.
        },
        tablet: {
            breakpoint: { max: 1024, min: 500 },
            items: 2,
            partialVisibilityGutter: 50 // this is needed to tell the amount of px that should be visible.
        },
        mobile: {
            breakpoint: { max: 500, min: 0 },
            items: 1,
            partialVisibilityGutter: 50 // this is needed to tell the amount of px that should be visible.
        }
    }

    const responsive3 = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3,
            // partialVisibilityGutter: 40 // this is needed to tell the amount of px that should be visible.
        },
        tablet: {
            breakpoint: { max: 1024, min: 500 },
            items: 2,
            partialVisibilityGutter: 50 // this is needed to tell the amount of px that should be visible.
        },
        mobile: {
            breakpoint: { max: 500, min: 0 },
            items: 1,
            partialVisibilityGutter: 50 // this is needed to tell the amount of px that should be visible.
        }
    }



    let html = (
        <Row id="card-section" className='bg-white'>
            {
                (typeof cardItems !== 'undefined') ? (
                    (cardItems).map((item, i) => {
                        let cardDetail = <Col key={'activity_' + i} className="px-md-0  d-flex align-items-stretch">
                            <Card className="mx-lg-3 my-2 border-radius-125 no-border-line activity-card" >
                                <Card.Img variant="top" src={item.image} className="border-radius-top-125" />
                                <Card.Body className="d-flex flex-column text-center">
                                    <Card.Title> <h4 className="card-description py-1">
                                        <div dangerouslySetInnerHTML={{ __html: item.description }} />
                                    </h4>
                                        <div className="text-center">
                                            {item.csvLink ? (

                                                <span id={item.csvId} onClick={() => exportLink(item.csvLink)}> <u className="t-14 text-green-evaluate click-pointer font-sarabun" >ดาวน์โหลดข้อมูล .CSV</u></span>
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                    </Card.Title>

                                    <div className="mt-auto">
                                        {item.onClick ? (
                                            <span id={item.id} onClick={() => exportLink(item.onClick)}> <button className="btn bluesky card-btn" >{item.btnText} </button></span>
                                        ) : (
                                            <a id={item.id} href={item.link}> <button className="btn bluesky card-btn" >{item.btnText} </button></a>
                                        )}
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                        allData.push(cardDetail);
                    }
                    )) : (
                    <div></div>
                )

            }

            <MultiCarouselPage data={allData} responsive={allData.length > 3 ? responsive2 : responsive3} />
        </Row>
    );

    return (
        <>
            <div className="card-report bg-white">
                {html}
            </div>
        </>
    )


}

export default MenuCard